import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'

const apiUrl = `${urlPrefix}/external/CAM`
//#region select数据源相关api
const GetDiscover = (unitId: number) => `${apiUrl}/discover/${unitId}`
const UpdateDeviceOnline = () => `${apiUrl}/device/online`
const UpdateCameraOnline = () => `${apiUrl}/camera/online`
const SaveDevice = (unitId: number) => `${apiUrl}/import/${unitId}`
const GetPreviewURLs = (indexCode: string) => `${apiUrl}/camera/previewURLs/${indexCode}`
//#endregion

/** 获取监控点预览取流URLv2 */
export const getPreviewURLs = (indexCode: string) => {
    return tryAxios({
        method: 'post',
        url: GetPreviewURLs(indexCode)
    })
}
/** 发现设备 */
export const getDiscover = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetDiscover(unitId)
    })
}
/** 更新设备在线状态 */
export const updateDeviceOnline = () => {
    return tryAxios({
        method: 'post',
        url: UpdateDeviceOnline()
    })
}
/** 更新监控点在线状态 */
export const updateCameraOnline = () => {
    return tryAxios({
        method: 'post',
        url: UpdateCameraOnline()
    })
}

export const saveDevice = (unitId: number, form: any) => {
    return tryAxios({
        method: 'post',
        url: SaveDevice(unitId),
        data: form
    })
}